import React from 'react';
import Img from 'gatsby-image';

interface DispatchProps {}
interface StateProps {}
interface OwnProps {
	index: any;
	onClick: any;
	photo: any;
	margin: any;
	direction: any;
	top: any;
	left: any;
}
type Props = DispatchProps & StateProps & OwnProps;
type State = {};
const cont: any = {
	backgroundColor: '#eee',
	cursor: 'pointer',
	overflow: 'hidden',
	position: 'relative'
};

const PortfolioImage = ({ index, onClick, photo, margin, direction, top, left }) => {
	if (direction === 'column') {
		cont.position = 'absolute';
		cont.left = left;
		cont.top = top;
	}
	return (
		<div
			key={index}
			style={{ margin, height: photo.height, width: photo.width, ...cont }}
			className={!photo.selected ? 'not-selected' : ''}
		>
			<div className='uk-text-center'>
				<div className='uk-inline-clip uk-transition-toggle' tabIndex={1}>
					<img
						data-src={photo.src}
						width={photo.width}
						height={photo.height}
						alt={photo.alt}
						data-uk-img
						onClick={(e) => onClick(e, { index, photo })}
					/>
					<style>{`.not-selected:hover{outline:2px solid #a9a9a9}`}</style>
					<div className='uk-transition-fade uk-position-cover uk-overlay carousel-cover'>
						<div style={{ height: '100%' }} className='uk-flex uk-flex-middle uk-flex-center'>
							<p style={{ color: 'white', fontSize: '22px' }} className='uk-margin-remove uk-padding'>
								{photo.caption}
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PortfolioImage;
